import styled from "styled-components";
import {TextField} from "@mui/material";
import {colors} from "styles/colors";

export const StyledTextField = styled(TextField)`
  input[disabled] {
    background-color: ${colors.disabled};
  }
`